import { ChevronDownIcon } from 'lucide-react'
import type { ComponentProps } from 'react'
import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

type NativeSelectProps = Omit<ComponentProps<'select'>, 'size'> & {
  size?: 'sm' | 'default'
}

const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, size = 'default', ...props }, ref) => {
    return (
      <div
        className={cn('group/native-select relative w-fit has-[select:disabled]:opacity-50', className)}
        data-size={size}
        data-slot="native-select-wrapper"
      >
        <select
          className="h-10 w-full min-w-0 select-none appearance-none rounded-lg border border-input bg-transparent py-1 pr-8 pl-2.5 text-base outline-none transition-colors selection:bg-primary selection:text-primary-foreground  placeholder:text-muted-foreground/70 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-[size=sm]:py-0.5 dark:bg-input/30 dark:aria-invalid:border-destructive/50  dark:aria-invalid:ring-destructive/40 dark:hover:bg-input/50 [&_optgroup]:bg-popover [&_optgroup]:text-popover-foreground [&_option]:bg-popover [&_option] "
          data-size={size}
          data-slot="native-select"
          {...props}
          ref={ref}
        />
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 select-none text-muted-foreground"
          data-slot="native-select-icon"
        />
      </div>
    )
  }
)

NativeSelect.displayName = 'NativeSelect'

function NativeSelectOption({ className, ...props }: ComponentProps<'option'>) {
  return (
    <option
      className={cn('bg-[Canvas] text-[CanvasText]', className)}
      data-slot="native-select-option"
      {...props}
    />
  )
}

function NativeSelectOptGroup({ className, ...props }: ComponentProps<'optgroup'>) {
  return (
    <optgroup
      className={cn('bg-[Canvas] text-[CanvasText]', className)}
      data-slot="native-select-optgroup"
      {...props}
    />
  )
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption }
